@if (skeleton()) {
    <lib-skeleton-loader [theme]="{ 'width.px': 32, 'height.px': 20 }"></lib-skeleton-loader>
} @else {
    <div class="flex items-center w-full gap-2">
        <input #input [id]="id()" [disabled]="state() === 'disabled'" [required]="required()"
            (keyup)="$event.key === 'Enter' && input.click()" type="checkbox" [(ngModel)]="_value" class="w-[35px] min-w-[35px] h-[20px] bg-background
            checked:bg-primary border-1 border-solid border-border-solid checked:border-primary rounded-md
            relative cursor-pointer disabled:cursor-default disabled:opacity-50 appearance-none peer select-none
            checked:hover:border-primary checked:focus:border-primary checked:hover:bg-primary checked:focus:bg-primary checked:bg-none
            focus-visible:ring-0 focus-visible:outline-0 focus:ring-0 focus:ring-offset-0 
    
            before:w-4 before:h-4 before:absolute before:content-[''] before:bg-primary before:checked:bg-background before:rounded-[5px]
            before:m-[1px] before:checked:right-0 before:focus-visible:ring-[5px] before:focus-visible:ring-[#4043DD33]" />
        <span class="peer-disabled:opacity-50 label-semibold leading-[20px] cursor-pointer peer-disabled:cursor-default text-foreground"
            (click)="input.click()"><ng-content></ng-content></span>
    </div>
}